import { detectOS, CSS_CLASS_PREFIX, CSS_CLASS_SUFFICES } from "./OSDetection";
const debugString = "";
const SHOW_DETECTED_OS_DATA = false;
const showOSName = (OSName) => {
    const newElement = document.createElement("div");
    newElement.innerHTML = `OS: ${OSName}`;
    newElement.style.background = "lightblue";
    newElement.style.padding = "10px";
    if (document.body.firstChild) {
        document.body.insertBefore(newElement, document.body.firstChild);
    }
    else {
        document.body.appendChild(newElement);
    }
};
const addClassOnDocument = (OSName) => {
    const cssClassOS = `${CSS_CLASS_PREFIX}--${CSS_CLASS_SUFFICES.os}--${OSName.toLowerCase()}`;
    document.documentElement.classList.add(cssClassOS);
};
const initializeBrowserDetection = () => {
    const OSName = detectOS();
    if (SHOW_DETECTED_OS_DATA) {
        showOSName(OSName + debugString);
    }
    addClassOnDocument(OSName);
    console.debug("Initializing browser detection...", OSName, debugString);
};
if (typeof window !== "undefined") {
    document.addEventListener("DOMContentLoaded", initializeBrowserDetection);
}
